module.exports = __webpack_public_path__ + "static/media/Let Me In - Instrumental Version.93588da0.jpg";